import axios from "@/axios";
import { defineStore } from "pinia";

export const useTownSelectionStore = defineStore("townSelection", {
  state: () => ({
    townsState: new Set(),
    idsState: {},
    epci: {},
  }),
  getters: {
    towns: (state) => [...state.townsState].map((id) => state.idsState[id]),
    ids: (state) => [...state.townsState],
    townIsSelected: (state) => (townId) => state.townsState.has(townId),
    epciIsSelected: (state) => (epciId) =>
      state.epci[epciId] && state.epci[epciId].selected === true,
  },
  actions: {
    setTowns(towns) {
      this.townsState = new Set(towns.map(({ id }) => id));
      towns.forEach((t) => {
        this.idsState[t.id] = { ...t };
      });
    },
    toggle(town) {
      const has = this.townsState.has(town.id);
      if (!has) {
        this.townsState = new Set(this.townsState.add(town.id));
        this.idsState[town.id] = { ...town };
      } else {
        this.townsState = new Set(
          [...this.townsState].filter((townId) => townId !== town.id)
        );
      }
    },
    toggleEpci({ id }) {
      this.epci[id].selected = !this.epci[id].selected;
    },
    addTown(town) {
      this.townsState = new Set(this.townsState.add(town.id));
      this.idsState[town.id] = { ...town };
    },
    addTowns(towns) {
      this.townsState = new Set(
        [...this.townsState].concat(towns.map(({ id }) => id))
      );
      towns.forEach((t) => {
        this.idsState[t.id] = { ...t };
      });
    },
    removeTown({ id }) {
      this.townsState = new Set(
        [...this.townsState].filter((townId) => townId !== id)
      );
    },
    removeTowns(towns) {
      const removed = new Set(towns.map(({ id }) => id));
      this.townsState = new Set(
        [...this.townsState].filter((id) => !removed.has(id))
      );
    },
    clearTowns() {
      this.townsState = new Set([]);
    },
    identifyEpci({ id, name, code, towns }) {
      this.epci[id] = {
        id,
        name,
        code,
        towns,
        selected: false,
      };
    },
    async epciTowns({ id, name, code }) {
      try {
        if (this.epci[id]) return this.epci[id].towns;
        const results = await axios.get(`/api/epci/${id}/towns`);
        const { data: towns } = results;
        this.identifyEpci({
          id,
          name,
          code,
          towns,
        });
        return towns;
      } catch (err) {
        console.error(err);
        return null;
      }
    },
  },
});
